/**
 * Intercom z-index is set to `2147483000`, therefore to make chat accessible we make our indexes lower than that
 * Only exception is tooltip, which is set to `2147483001` to be above the chat.
 */
const INTERCOM_Z_INDEX = 2147483000;

/** 2147482500 - ImpersonationContainer */
const IMPERSONATION_Z_INDEX = INTERCOM_Z_INDEX - 500;

/** 2147482000 - ModalPortal */
const PORTAL_Z_INDEX = INTERCOM_Z_INDEX - 1000;

/** 2147481000 - NavigationFrame, Aside, Drawers */
const TOP_Z_INDEX = INTERCOM_Z_INDEX - 2000;

/** Higher to lower z-index */
const zIndex = {
  tooltip: INTERCOM_Z_INDEX + 1,
  intercom: INTERCOM_Z_INDEX,
  toasts: INTERCOM_Z_INDEX - 1,
  impersonation: IMPERSONATION_Z_INDEX,
  portal: PORTAL_Z_INDEX,
  top: TOP_Z_INDEX,
  dropdown: 7000,
  footer: 900,
  minimum: 1,
};

export type SystemZIndexMap = typeof zIndex;
export type SystemZIndex = keyof SystemZIndexMap;
export default zIndex;
